import { useCorpus } from "../../api/queries";
import { StatePill } from "../../components/StatePill";

/**
 * The Develop landing table's "Corpus" column (IA slice 3): one bounded
 * `useCorpus` fetch per row (one small page, `sourceCommit`/`items` only —
 * same per-row-fetch precedent as `PlacementsSummaryCell`, not a project-wide
 * "corpus summary" endpoint that doesn't exist). Renders exactly what the
 * server said: synced (a real applied commit), pending (nothing applied
 * yet), or nothing at all while it loads — never a fabricated state (A-10).
 */
export function CorpusStatePillCell({ projectId }: { projectId: string }) {
  const { data, isPending } = useCorpus(projectId);

  if (isPending) return <span className="data-table__secondary">…</span>;

  const synced = Boolean(data?.sourceCommit);
  return synced ? (
    <StatePill label="Corpus applied" tone="positive" shape="dot" />
  ) : (
    <StatePill label="No corpus yet" tone="neutral" shape="ring" />
  );
}
